import React, {useState, useEffect, useRef}  from 'react';
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../layout/Layout";
import moment from 'moment';

import { useropen } from '../../redux/userInfo';
import { open, close, loadingflas } from '../../redux/popupSlice';
import { Link, useNavigate } from 'react-router-dom';
import consts from '../../libs/consts';


import Input from '../../component/Input';
import Button from '../../component/Button';
import Radios from '../../component/Radios';
import Profiles from '../../component/Profiles';
import MypageleftArea from '../../component/MypageleftArea';
import DaumPostcode from 'react-daum-postcode';


import { Ismobiles, getBase64, getMemberinfo } from "../../utils/utils";


import * as APIS from "../../utils/service";
import Select from '../../component/Select';

export default function CompanyInfo({ navigation }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { configdata } = useSelector(s => s.configReducer);
    const [memberinfos, setmemberinfos] = useState(''); 

    const [desc, setdesc] = useState('');   
    const selectFile = useRef(null);


    const [isOpenPost, setIsOpenPost] = useState(false);
    const [addrDatas, setaddrDatas] = useState({});   
    const [detail_addr, setdetail_addr] = useState(''); //상세주소
    const [errmsg, seterrmsg] = useState(['', '', '', '']);   
    const [leave_option, setleave_option] = useState(1);   
    const [share_option, setshare_option] = useState(1);   


    let leavelists = configdata?.consts?.leaveOptionConsts;
    let sharelists = configdata?.consts?.shareOptionConsts;
    let leavechData = [];
    leavelists?.map((x, i) => {
        leavechData.push({
            // names: x?.title,
            comments: x?.desc,
            values: x?.idx,
        });
    });
    let sharelistsData = [];
    sharelists?.map((x, i) => {
        sharelistsData.push({
            // names: x?.title,
            comments: x?.desc,
            // comments2:x?.desc2,
            values: x?.idx,
        });
    });
    const [leaveOptionlist, setleaveOptionlist] = useState(leavechData);   

    useEffect(() => {
        getMemberinfo(setmemberinfos);
    }, []);
    useEffect(() => {
        console.log(memberinfos);
        setleave_option(memberinfos?.compony?.leave_option);
        setshare_option(memberinfos?.compony?.share_option);
        setdetail_addr(memberinfos?.compony?.detail_addr);
        setaddrDatas({
            addr: memberinfos?.compony?.addr,
            sido: memberinfos?.compony?.sido,
            sigungu: memberinfos?.compony?.sigungu
        });

    }, [memberinfos]);


    useEffect(() => {
        seterrmsg(errmsg?.map(( xe, ie ) => ''));
        
    }, []);

    
    const postBoxStyle = {
        display: 'block',
        position: 'relative',
        width: '100%',
        border: '1px solid #000',
        marginTop: 5,
        textAlign: 'right'
    };
    const postCodeStyle = {
        width: '100%',
        borderTop: '1px solid #000',
    };
    const onCompletePost = (data) => {
        let fullAddr = data.address;
        let extraAddr = '';

        //console.log('data', data);
        
        //let jibunAddress = jibunAddress;

        if (data.addressType === 'R') {
            if (data.bname !== '') {
                extraAddr += data.bname;
            }
            if (data.buildingName !== '') {
                extraAddr += extraAddr !== '' ? `, ${data.buildingName}` : data.buildingName;
            }
            fullAddr += extraAddr !== '' ? ` (${extraAddr})` : '';
        }
        console.log(data);

        setaddrDatas({
            addr: data.address,
            sido: data?.sido,
            sigungu: data?.sigungu || data?.sido
        });
        
        setIsOpenPost(false);
    };

    return(
        <>
        <Layout header={false} actives={''}>
            <div className='mypagearea'>
                <div >
                    <MypageleftArea pages={1} />
                </div>
                <div 
                    className='padding32'
                >
                    <div className='pagetitle fontsize20 bolds'>사무소관리</div>
                    <div className='pagetabs margint20'>
                        <button onClick={() => { navigate('/CompanyNotice') }}>사내공지</button>
                        <button className='active' onClick={() => { navigate('/CompanyInfo') }}>사무소정보</button>
                        {/* <button onClick={() => { navigate('/CompanyCalc') }}>정산</button> */}
                    </div>
                    
                    <input type='file' ref={selectFile} style={{ display: 'none' }} onChange={(e) => {
                        let file = e.target.files[0];
                        getBase64(file).then(result => {
                            file["base64"] = result;
                            file["ext"] = file.name.split('.')[1];
                            let sender = {
                                logo_path: {
                                    base: result,
                                    ext: file.name.split('.')[1]
                                },
                                delete_files: memberinfos?.compony?.logo_path,
                            }
                            console.log(sender);
                            dispatch(loadingflas({ loading: true }));
                            APIS.postData('/v1/master/logo', sender).then(({ data }) => {
                                if(data){
                                    getMemberinfo(setmemberinfos);
                                }
                            }).catch(({ response }) => {
                                const { data } = response;
                            }).finally(() => {
                                dispatch(loadingflas({ loading: false }));
                            });  
                        })
                        .catch(err => { console.log(err); });
                    }} /> 
                    <div className='mypageinputsarea margint20' style={{ gap: 32 }}>
                        <div className='companyProfile' style={{ position: 'relative' }}>
                                                          
                            <div
                                style={{
                                    backgroundImage: `${memberinfos?.compony?.logo_path ? "url('"+ consts.s3url +"/"+ memberinfos?.compony?.logo_path +"')" : "url('./images/icons/community-line.svg')"}`,
                                    cursor: 'pointer', position: 'relative',
                                    backgroundSize: `${memberinfos?.compony?.logo_path ? "cover" : ""}`
                                }}
                                onClick={() => {
                                    selectFile.current.click();
                                }}
                            />
                            <div>
                                <div className='bolds fontsize24'>{memberinfos?.compony?.title}</div>
                                <div>사업자번호 {memberinfos?.compony?.business_number}</div>
                                <div>대표번호 {memberinfos?.compony?.company_phone}</div>
                            </div>
                            {memberinfos?.compony?.logo_path &&
                            <button 
                                type='button'
                                onClick={() => {

                                    dispatch(
                                        open({
                                            component: '삭제하시겠습니까?',
                                            title: '알림',
                                            button: "확인",
                                            buttonCencle: "취소",       
                                            titleviewer: true,                 
                                            alert: false,
                                            onPress: () => {
                                                let sender = {
                                                    logo_path: null,
                                                    delete_files: memberinfos?.compony?.logo_path,
                                                }
                                                console.log(sender);
                                                dispatch(loadingflas({ loading: true }));
                                                APIS.postData('/v1/master/logo', sender).then(({ data }) => {
                                                    if(data){
                                                        getMemberinfo(setmemberinfos);
                                                        dispatch(close());
                                                    }
                                                }).catch(({ response }) => {
                                                    const { data } = response;
                                                }).finally(() => {
                                                    dispatch(loadingflas({ loading: false }));
                                                });    
                                                
                                            },
                                            onCancelPress: () => {
                                                dispatch(close());
                                            }
                                        })
                                    );  
                                }}
                                style={{
                                    backgroundColor: '#333', width: 32, height: 32, position: 'absolute', left: -10, top: -10,
                                    borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center'
                                }}
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M14.1667 4.99999H18.3333V6.66666H16.6667V17.5C16.6667 17.9602 16.2936 18.3333 15.8333 18.3333H4.16667C3.70644 18.3333 3.33334 17.9602 3.33334 17.5V6.66666H1.66667V4.99999H5.83334V2.49999C5.83334 2.03976 6.20644 1.66666 6.66667 1.66666H13.3333C13.7936 1.66666 14.1667 2.03976 14.1667 2.49999V4.99999ZM15 6.66666H5.00001V16.6667H15V6.66666ZM7.5 9.16666H9.16667V14.1667H7.5V9.16666ZM10.8333 9.16666H12.5V14.1667H10.8333V9.16666ZM7.5 3.33332V4.99999H12.5V3.33332H7.5Z" fill="#fff"/>
                                </svg>  
                            </button>  
                            }
                        </div>
                        <div style={{ display: 'flex', alignItems: 'flex-start', flexDirection: 'column', gap: 8 }}>
                            <div className='fontsize16 bolds'>주소</div>
                            <div className="inputviewtype1 " style={{ marginTop: 0, width: '100%', }}>
                                <div style={{ flexDirection: 'column', alignItems: 'flex-start', width: '100%', marginTop: 0 }}>
                                    <div className='buttonWithTxt' style={{ marginTop: 8 }}>
                                        <div style={{ width: 0 }}>
                                            {/* <Button
                                                className={'normalbutton_middle'}
                                                buttonTxt={'주소찾기'}
                                                onPress={() => {
                                                    setIsOpenPost(true);
                                                }}
                                            /> */}
                                        </div>
                                        <div style={{ width: '100%'}}>
                                            {addrDatas?.addr}
                                        </div>
                                    </div>
                                    {isOpenPost  ? (
                                        <div style={postBoxStyle}>
                                            <button type="button" className="addrbtn exit_btn" onClick={() => setIsOpenPost(false)} style={{ padding: 10 }}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                                    <path fillRule="evenodd" clipRule="evenodd" d="M5.29289 5.79289C5.68342 5.40237 6.31658 5.40237 6.70711 5.79289L12 11.0858L17.2929 5.79289C17.6834 5.40237 18.3166 5.40237 18.7071 5.79289C19.0976 6.18342 19.0976 6.81658 18.7071 7.20711L13.4142 12.5L18.7071 17.7929C19.0976 18.1834 19.0976 18.8166 18.7071 19.2071C18.3166 19.5976 17.6834 19.5976 17.2929 19.2071L12 13.9142L6.70711 19.2071C6.31658 19.5976 5.68342 19.5976 5.29289 19.2071C4.90237 18.8166 4.90237 18.1834 5.29289 17.7929L10.5858 12.5L5.29289 7.20711C4.90237 6.81658 4.90237 6.18342 5.29289 5.79289Z" fill="#999999"/>
                                                </svg>                            
                                            </button>
                                            <DaumPostcode style={postCodeStyle} autoClose onComplete={onCompletePost} />
                                        </div>
                                    ) : null}      

                                    <div className='inputArea' style={{ width: '100%' }}>
                                        <Input 
                                            className={`inputs`}
                                            setValue={setdetail_addr}
                                            value={detail_addr}
                                            name="searchvar"
                                            label={'상세주소'}
                                            labelstyle={2}
                                            requireds={true}
                                            customplaceholder={true}
                                            customplaceholdertxt={'상세주소'}                        
                                            error={errmsg[2]}
                                            // withButton={'저장'}
                                            withButtonPress={() => {

                                                if(detail_addr === ''){
                                                    seterrmsg(errmsg?.map(( xe, ie ) => ie === 2 ? '상세주소를 입력해주세요.' : xe));
                                                    return;
                                                }
                                                                                                
                                                let sender = {
                                                    sido: addrDatas?.sido,
                                                    sigungu: addrDatas?.sigungu,
                                                    addr: addrDatas?.addr,
                                                    detail_addr: detail_addr
                                                }
                                                dispatch(loadingflas({ loading: true }));
                                                APIS.postData('/v1/master/addrUpdate', sender).then(({ data }) => {
                                                    if(data){
                                                        getMemberinfo(setmemberinfos);
                                                    }
                                                }).catch(({ response }) => {
                                                    const { data } = response;
                                                    seterrmsg(errmsg?.map(( xe, ie ) => ie === 2 ? data?.msg : xe));
                                                }).finally(() => {
                                                    dispatch(loadingflas({ loading: false }));
                                                });   
                                            }}
                                            withstyle={{
                                                width: 120
                                            }}
                                            withButtonLong={true}
                                        />                    
                                    </div> 
                                </div>
                            </div>   
                        </div>  
                        <div>
                            <div className='radiowp100'>
                                {/* <div>임직원 정보 공유 여부 설정</div> */}
                                <div>임직원 AI 매칭</div>
                                <div>
                                    <Radios
                                        linetype={'comment'}
                                        values={share_option}
                                        setvalues={setshare_option}
                                        namevalue={sharelistsData}
                                        flexDirection={'column'}
                                    />  
                                </div>
                
                                <div >
                                    <Button
                                        className={'normalbutton'}
                                        buttonTxt={'변경'}
                                        onPress={() => { 

                                            let sharelistfind = sharelistsData?.find((x, i) => x?.values*1 === share_option*1 )
                                            dispatch(
                                                open({
                                                    component: <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: 20}}>
                                                        <p className='bolds fontsize20'>{sharelistfind?.names}</p>
                                                        <p>설정을 변경하시겠습니까?</p>
                                                    </div>,
                                                    title: '임직원 정보 공유 설정',
                                                    button: "확인",
                                                    buttonCencle: "취소",       
                                                    titleviewer: true,                 
                                                    alert: false,
                                                    onPress: () => {
                                                        let sender = {
                                                            share_option: share_option*1,
                                                        }
                                                        console.log(sender);
                                                        dispatch(loadingflas({ loading: true }));
                                                        APIS.postData('/v1/master/shareOptionUpdate', sender).then(({ data }) => {
                                                            if(data){
                                                                console.log(data);
                                                                getMemberinfo(setmemberinfos);
                                                                dispatch(
                                                                    open({
                                                                        component: '설정이 저장되었습니다.',
                                                                        title: '알림',
                                                                        button: "확인",
                                                                        titleviewer: true,                 
                                                                        alert: false,
                                                                        onPress: () => {
                                                                            dispatch(close());
                                                                        },
                                                                    })
                                                                ); 
                                                            }
                                                        }).catch(({ response }) => {
                                                            const { data } = response;
                                                            console.log(data);
                                                        }).finally(() => {
                                                            dispatch(loadingflas({ loading: false }));
                                                        });  
                                                    },
                                                    onCancelPress: () => {
                                                        dispatch(close());
                                                    }
                                                })
                                            );  

                                                                                        
                                        }}
                                        styles={{ width: 120 }}
                                    />
                                </div>
                                                
                            </div>
                        </div>                          
                        <div>
                            <div className='radiowp100'>
                                {/* <div>매물/고객 정보 귀속 여부 설정</div> */}
                                <div>퇴사 후 매물장 소유 주체</div>
                                <div>
                                    <Radios
                                        linetype={'comment'}
                                        values={leave_option}
                                        setvalues={setleave_option}
                                        namevalue={leaveOptionlist}
                                        flexDirection={'column'}
                                    />  
                                </div>
                
                                <div >
                                    <Button
                                        className={'normalbutton'}
                                        buttonTxt={'변경'}
                                        onPress={() => { 

                                            let leavelistfind = leavechData?.find((x, i) => x?.values*1 === leave_option*1 )
                                            dispatch(
                                                open({
                                                    component: <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: 20}}>
                                                        <p className='bolds fontsize20'>{leavelistfind?.names}</p>
                                                        <p>설정을 변경하시겠습니까?</p>
                                                    </div>,
                                                    title: '매물/고객정보 귀속 설정',
                                                    button: "확인",
                                                    buttonCencle: "취소",       
                                                    titleviewer: true,                 
                                                    alert: false,
                                                    onPress: () => {
                                                        let sender = {
                                                            leave_option: leave_option,
                                                        }
                                                        console.log(sender);
                                                        dispatch(loadingflas({ loading: true }));
                                                        APIS.postData('/v1/master/leaveOptionUpdate', sender).then(({ data }) => {
                                                            if(data){
                                                                getMemberinfo(setmemberinfos);
                                                                dispatch(
                                                                    open({
                                                                        component: '설정이 저장되었습니다.',
                                                                        title: '알림',
                                                                        button: "확인",
                                                                        titleviewer: true,                 
                                                                        alert: false,
                                                                        onPress: () => {
                                                                            dispatch(close());
                                                                        },
                                                                    })
                                                                ); 
                                                            }
                                                        }).catch(({ response }) => {
                                                            const { data } = response;
                                                        }).finally(() => {
                                                            dispatch(loadingflas({ loading: false }));
                                                        });  
                                                    },
                                                    onCancelPress: () => {
                                                        dispatch(close());
                                                    }
                                                })
                                            );  

                                                                                        
                                        }}
                                        styles={{ width: 120 }}
                                    />
                                </div>
                                                
                            </div>
                        </div>                              
                        <div>
                            <p className='fontsize16 bolds'>사무소 폐업을 원하시나요?</p>
                            <button
                                onClick={() => {
                                    navigate('/CompanyworkEnd');
                                }}
                                style={{ textDecoration: 'underline', marginTop: 8 }}
                            >
                                사무소 폐업신청
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>

        </>
    )
}

